import React, {Component} from 'react';
import PropTypes from 'prop-types';
import FeedbackLinks from '../FeedbackLinks/FeedbackLinks';
import Modal from '@homeaway/react-modal';
import FeedbackTab from '../FeedbackTab/FeedbackTab';
import OpinionLab from '../../utils/OpinionLab';

class Feedback extends Component {
    static propTypes = {
        /** Object containing lingua translations for the current locale. It is assumed that the parent app will prepare and provide the lingua object matching the shape seen here. */
        lingua: PropTypes.shape({
            tabText: PropTypes.string,
            title: PropTypes.string,
            reviewLink: PropTypes.string,
            reviewLinkText: PropTypes.string,
            helpLink: PropTypes.string,
            helpLinkText: PropTypes.string,
            supportLinkText: PropTypes.string,
            externalLinkSrText: PropTypes.string
        }),
        /** Desired position on screen to render the feedback tab. Valid options are: left, right, and bottom */
        tabPosition: PropTypes.oneOf(['bottom', 'right', 'left']),
        /** allows consuming app to customize the feedback tab via a string of classnames that will be applied to the feedback tab */
        feedbackTabClassList: PropTypes.string,
        /** Disable rendering of OpinionLab site feedback option which also prevents loading associated scripts */
        disableSiteFeedback: PropTypes.bool
    };

    static defaultProps = {
        lingua: {
            tabText: 'Feedback',
            title: 'Feedback',
            reviewLink:
                'https://help.homeaway.com/articles/How-do-I-submit-a-review',
            reviewLinkText: 'I would like to leave a review for a property',
            helpLink: 'https://help.homeaway.com/',
            helpLinkText:
                'I have an issue or question and would like some help',
            supportLinkText: 'I want to leave a comment for this web site',
            externalLinkSrText: 'Opens in a new window'
        },
        tabPosition: 'bottom',
        feedbackTabClassList: 'Feedback__tab btn btn-default',
        disableSiteFeedback: false
    };

    constructor(props) {
        super(props);

        this.state = {
            isOpen: false
        };
    }

    componentDidMount() {
        this.opinionLabInstance = new OpinionLab();
    }

    handleOpen = () => {
        this.handleOpenAndLoad();
    };

    handleOnPress = (e) => {
        const code = e.charCode || e.keyCode;
        if (code === 32 || code === 13) {
            // Check if enter key or space bar were pressed
            this.handleOpenAndLoad();
        }
    };

    handleClose = () => {
        this.setState({isOpen: false});
        OpinionLab.cleanUpFormElement();
    };

    handleOpenAndLoad = () => {
        const currentisOpen = this.state.isOpen;

        this.setState({isOpen: !currentisOpen});
        if (!this.props.disableSiteFeedback) {
            this.opinionLabInstance.loadScript();
        }
    };

    setDialogFocus = () => {
        if (typeof document !== 'undefined') {
            document.getElementById('react-feedback').focus();
        }
    };

    render() {
        const {
            tabPosition,
            lingua,
            feedbackTabClassList,
            disableSiteFeedback,
            className
        } = this.props;

        return (
            <FeedbackTab
                isOpen={this.state.isOpen}
                onClick={this.handleOpen}
                onPress={this.handleOnPress}
                tabText={lingua.tabText}
                tabPosition={tabPosition}
                feedbackTabClassList={feedbackTabClassList}
                className={className}
            >
                <Modal
                    id="react-feedback"
                    isOpen={this.state.isOpen}
                    onClose={this.handleClose}
                    onModalOpen={this.setDialogFocus}
                    title={lingua.title}
                >
                    <FeedbackLinks
                        lingua={lingua}
                        opinionLabInstance={this.opinionLabInstance}
                        disableSiteFeedback={disableSiteFeedback}
                    />
                </Modal>
            </FeedbackTab>
        );
    }
}

export default Feedback;
